import { User } from "@/schemas/User"
import { addDays, formatISO } from "date-fns"

export function genUser(
  email: string = "email@example.com",
  firstName: string = "First",
  lastName: string = "Last",
) {
  const fakeUser: User = {
    account: {
      announcementLastAckedAt: null,
      badgeIssuedAt: null,
      badgrEntityId: null,
      badgrValidationEmail: null,
      createdAt: "",
      deletedAt: null,
      email,
      firstName,
      lastName,
      lastViewedSectionUuid: "088b8332-aaaa-48d9-bbc7-e673d392f347",
      newContentDismissedAt: null,
      notificationLastAckedAt: null,
      platformLastAccessTime: "",
      preferredLanguage: null,
      sansUserId: null,
      suspended: false,
      termsConditionsEthicsAcknowledgedAt: "",
      uuid: "12341234-1234-1234-1234-123412341234",
    },
    cdn: {
      "CloudFront-Key-Pair-Id": "CloudFront-Key-Pair-Id",
      "CloudFront-Policy": "CloudFront-Policy",
      "CloudFront-Signature": "CloudFront-Signature",
      expiresAt: "",
    },
    license: {
      activatedAt: "",
      code: "12341234-1234-1234-1234-123412341234",
      courseIteration: 2,
      expiresAt: formatISO(addDays(new Date(), 7)),
      isDemo: false,
      isExpired: false,
      isRevoked: false,
      licenseTagUuid: "",
      startsAt: "",
      status: "ACTIVE",
    },
  }
  return fakeUser
}
